import { apiGet } from '../client';
import type { AdminStats, Customer, CustomerDetail, Role } from '@/types/api';

/**
 * The internal operations console. Every endpoint here is administrator-only and
 * scoped to nobody — these describe the product and its customers, not a caller's
 * own vehicles.
 */

export function fetchAdminStats(): Promise<AdminStats> {
  return apiGet<AdminStats>('/admin/stats');
}

export function listCustomers(filters: { q?: string; role?: Role } = {}): Promise<Customer[]> {
  return apiGet<Customer[]>('/admin/customers', {
    query: { q: filters.q || undefined, role: filters.role },
  });
}

export function getCustomer(userId: number): Promise<CustomerDetail> {
  return apiGet<CustomerDetail>(`/admin/customers/${userId}`);
}
